import type { RouteObject } from "react-router";
import OAuthAuthorizePage from "@/src/oauth/pages/oauth-authorize-page";

export const oauthRoutes: RouteObject[] = [{ path: "/oauth/authorize", element: <OAuthAuthorizePage /> }];
